import { FC } from "react";
import { IconPropsType } from ".";

export const Upload: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="10"
      height="19"
      viewBox="0 0 10 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 17.5L5 7.5M9 10.5L5 6.5L1 10.5M9 1L1 0.999999"
        stroke={props.color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
